<template>
  <div id="test-paper-show">
    <!-- 试卷编辑界面 -->
    <div class="type" v-for="(item, index) in data" :key="index">
      <div class="title">
        {{ transitionNumToText(index) }}、{{ transitionName(item.type) }}（{{
          item.item.length
        }}题 / {{ item.typeTotalPoints }}分）
      </div>
      <div class="item" v-for="(que, ii) in item.item" :key="ii">
        <div class="title">
          {{ que.index }}、<span v-html="que.questionStem"></span>
          <span class="nd"
            >（难度：<i
              :class="{
                'el-icon-star-off': true,
                'el-icon-star-on': que.gradeOfDifficulty >= s,
              }"
              v-for="s in 5"
              :key="s"
            ></i
            >）（ {{ que.points }}分）</span
          >
        </div>
        <div class="xx" v-if="item.type == '0' || item.type == '1'">
          <!-- 选择题的选项值 -->
          <div class="itel" v-for="(qo, iii) in que.questionOptions" :key="iii">
            {{ qo.title }}、<span v-html="qo.value"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as paperData from "../../views/admin/question_bank/js/question.js";
export default {
  name: "diy_dialog_paper",
  props: {
    paperData: {
      type: Array,
      default: function () {
        return [
          {
            type: "0", // 题目类型  0 单选  1 多选 2 填空  3 判断  4 简答
            typeTotalPoints: "20", // 当前类型下总分
            item: [
              {
                index: "1",
                questionStem: "", // 题干 含html
                questionOptions: [
                  // 选择题的选择项组
                  { title: "A", value: "AAAA" },
                  { title: "B", value: "BBBB" },
                ],
                gradeOfDifficulty: 3, // 难度等级  1 2 3 4 5
                points: "2", // 本题分值
                questionId: "",
              },
            ],
          },
          {
            type: "1", // 题目类型  0 单选  1 多选 2 填空  3 判断  4 简答
            typeTotalPoints: "20", // 当前类型下总分
            item: [
              {
                index: "1",
                questionStem: "", // 题干 含html
                questionOptions: [
                  // 选择题的选择项组
                  { title: "A", value: "AAAA" },
                  { title: "B", value: "BBBB" },
                ],
                gradeOfDifficulty: 3, // 难度等级  1 2 3 4 5
                points: "2", // 本题分值
                questionId: "",
              },
            ],
          },
          {
            type: "2", // 题目类型  0 单选  1 多选 2 填空  3 判断  4 简答
            typeTotalPoints: "20", // 当前类型下总分
            item: [
              {
                index: "1",
                questionStem: "", // 题干 含html
                questionOptions: [
                  // 选择题的选择项组
                  { title: "A", value: "AAAA" },
                  { title: "B", value: "BBBB" },
                ],
                gradeOfDifficulty: 3, // 难度等级  1 2 3 4 5
                points: "2", // 本题分值
                questionId: "",
              },
            ],
          },
          {
            type: "3", // 题目类型  0 单选  1 多选 2 填空  3 判断  4 简答
            typeTotalPoints: "20", // 当前类型下总分
            item: [
              {
                index: "1",
                questionStem: "", // 题干 含html
                questionOptions: [
                  // 选择题的选择项组
                  { title: "A", value: "AAAA" },
                  { title: "B", value: "BBBB" },
                ],
                gradeOfDifficulty: 3, // 难度等级  1 2 3 4 5
                points: "2", // 本题分值
                questionId: "",
              },
            ],
          },
          {
            type: "4", // 题目类型  0 单选  1 多选 2 填空  3 判断  4 简答
            typeTotalPoints: "20", // 当前类型下总分
            item: [
              {
                index: "1",
                questionStem: "", // 题干 含html
                questionOptions: [
                  // 选择题的选择项组
                  { title: "A", value: "AAAA" },
                  { title: "B", value: "BBBB" },
                ],
                gradeOfDifficulty: 3, // 难度等级  1 2 3 4 5
                points: "2", // 本题分值
                questionId: "",
              },
            ],
          },
        ];
      },
    },
  },
  data() {
    return {
      data: this.paperData,
    };
  },
  watch: {
    paperData() {
      this.data = this.paperData;
    },
    data(newValue) {
      this.$emit("showPaper", this.data);
    },
  },
  methods: {
    /**
     * 小写数字转大写数字
     */
    transitionNumToText(num) {
      let text = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      return text[num];
    },
    /**
     *
     */ transitionName(type) {
      return paperData.initTableValue("topic", type);
    },
    /**
     * 具体题目的操作
     * item:具体题目
     * itemIndex:题目所在的索引
     * typeIndex:题目类型所在的索引
     * flag:具体操作  0 替换  1 上移  2 下移
     */
    changeClick(item, itemIndex, typeIndex, flag) {},
  },
};
</script>

<style lang="less" scoped>
#test-paper-show {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // background-color: #333;
  > .type {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    > .title {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 16px;
      font-weight: bold;
    }
    > .item {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #e9e9e9;
      box-sizing: border-box;
      margin-bottom: 20px;
      > .title {
        width: 100%;
        height: auto;
        line-height: 30px;
        display: flex;
        align-items: center;
        text-align: left;
        > .nd {
          margin-left: 10px;
          font-size: 14px;

          .el-icon-star-off {
            font-size: 15px;
            color: #e9e9e9;
          }
          .el-icon-star-on {
            color: #ffe710;
            font-size: 17px;
          }
        }
        /deep/ p {
          display: inline;
        }
      }
      > .xx {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        box-sizing: border-box;
        > .itel {
          width: 100%;
          height: auto;
          line-height: 30px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 5px;
          font-size: 15px;
          span {
            text-align: left;
          }
        }
      }
      > .op {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 10px;
        > .va {
          width: 80px;
          margin-right: 10px;
          display: flex;
          font-size: 15px;
          align-items: center;
          > span {
            margin-left: 5px;
          }
        }
        > .but {
          width: auto;
          padding: 0 5px;
          box-sizing: border-box;
          font-size: 14px;
          color: #2187fc;
          transition: 0.3s;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
            text-underline-offset: 5px;
          }
        }
      }
    }
  }
}
</style>